module.exports = __webpack_public_path__ + "img/2.36822561.jpg";